import React from "react";
import Frontend from "./content/Frontend";
import Design from "./content/Design";
import Practical from "./content/Practical";

export default function Skills() {
  return (
    <div id="skills" className="skills">
      <h3>
        Skills <div className="line-detail"></div>
      </h3>
      <div className="skills-body">
        <div className="skills__container">
          <ul className="skills__container__cards">
            <Frontend />
            <Design />
            <Practical />
          </ul>
        </div>
      </div>
    </div>
  );
}
